/**
 * Add a filter to convert help tokens into urls using the help service, so that
 * templates can use tokens directly without having to inject the service and use it
 * in controllers
 */

import { HelpService } from '../../commonInfra/services/HelpService';
import { Module } from '../Module';

// This is used in a pug file. Once that is converted, this filter can be removed.
Module.instance().filter('toServerHelpUrl', [() => {
  return function(token: string) {
    return HelpService.getServerHelpUrlByCategory(token);
  };
}]);
